import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BulletinBoardService {
  private _postsData$ = new BehaviorSubject<any>(null);
  public readonly postsData$ = this._postsData$.asObservable();
  _user$: any;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.user$.subscribe((user: any) => this._user$ = user)
  }

  clearPostData = () => {
    this._postsData$.next(null);
  }

  getPosts = ({
    activeFlag = 1, limit, offset = 0,
  }: {
    activeFlag: 1 | 0;
    limit: number;
    offset: number;
    }) => {
    const params: {
      loginName: string;
      activeFlag: 1 | 0;
      limit?: number;
      offset?: number;
    } = {
      loginName: this._user$.loginName,
      activeFlag,
    }

    if (limit) {
      params.limit = limit;
      params.offset = offset;
    }

    return this.http.get(`${environment.expressUrl}/bulletin-posts`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        params,
      })
  }

  getPost = (id: number) => {
    return this.http.get(`${environment.expressUrl}/bulletin-posts/${id}`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        params: { 'loginName': this._user$.loginName },
      })
      .subscribe({
        next: (response: any) => {
          this._postsData$.next(response.data);
        },
        error: (error) => {
          console.log('error', error);
        },
      })
  }

  addPost = (post: any) => {
    const postPayload = {
      loginName: this._user$.loginName,
      'content': post.content,
      'title': post.title,
    };

    return this.http.post(
      `${environment.expressUrl}/bulletin-posts`,
      postPayload,
      { headers: { 'Content-Type': 'application/vnd.api+json' } },
    );
  }

  updatePost = (post: any) => {
    return this.http.put(
      `${environment.expressUrl}/bulletin-posts/${post.id}`,
      {
        'loginName': this._user$.loginName,
        'content': post.content,
        'title': post.title,
      },
      { headers: { 'Content-Type': 'application/vnd.api+json' } },
    )
  }

  deletePost = (id: number) => {
    return this.http.delete(`${environment.expressUrl}/bulletin-posts/${id}`, {
      body: { 'loginName': this._user$.loginName },
      headers: { 'Content-Type': 'application/vnd.api+json' },
    })
  }
}
